import {
  useAssignSetting,
  useSetting,
} from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { BRAND_CENTRIC_SEARCH_250925 } from "@faire/web-api--source/indigofair/settings/BRAND_CENTRIC_SEARCH_250925";

export const useSettingEnableBrandCentricSearch = (): boolean =>
  useSetting(BRAND_CENTRIC_SEARCH_250925, false);

export const useAssignSettingEnableBrandCentricSearch = () =>
  useAssignSetting(BRAND_CENTRIC_SEARCH_250925);
